/* eslint-disable */
/* prettier-ignore-start */
// [GENERATED FILE; DO NOT EDIT BY HAND]

import React from "react"

var element = React.createElement("svg", {
  width: "12",
  height: "8",
  viewBox: "0 0 12 8",
  fill: "currentColor",
  "aria-hidden": "true"
}, React.createElement("path", {
  d: "M9.628.44a1.312 1.312 0 011.963.002c.546.594.544 1.545.002 2.133L7.003 7.56c-.275.3-.64.447-1.003.44a1.326 1.326 0 01-1.004-.44L.407 2.575A1.597 1.597 0 01.41.442 1.312 1.312 0 012.372.44L6 4.381 9.628.441z",
  fillRule: "evenodd"
}));

var Svg = React.forwardRef(function (props, ref) {
  var next = { ref: ref };
  for (var key in props) {
    if (props.hasOwnProperty(key)) {
      next[key] = props[key];
    }
  }
  return React.cloneElement(element, next);
});
Svg.displayName = "Dropdown";
Svg.element = element;
export default Svg;
